// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__3NtF_","colCheckbox":"styles_colCheckbox__kYv2o"};